import { render } from "./ScriptPage.vue?vue&type=template&id=e10c73d4"
import script from "./ScriptPage.vue?vue&type=script&lang=js"
export * from "./ScriptPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__